import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { ActionName } from '../../../constants';
export const extractAutomationAction = response => {
  var _response$meta, _response$meta$suppor;
  if (!getBooleanFF('platform.linking-platfom.smart-card.confluence.page.automation-action_xcdoi') || !response.data) {
    return undefined;
  }
  if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && (_response$meta$suppor = _response$meta.supportedFeature) !== null && _response$meta$suppor !== void 0 && _response$meta$suppor.includes(ActionName.AutomationAction))) {
    return undefined;
  }
  const data = response.data;
  const meta = response.meta;
  const {
    name,
    'atlassian:ari': objectAri
  } = data;
  const {
    product,
    tenantId,
    resourceType
  } = meta;
  return {
    product: product,
    resourceType: resourceType,
    siteAri: `ari:cloud:${product}::site/${tenantId}`,
    objectName: name,
    objectAri: objectAri,
    // TODO: The admin experience will be a follow up
    canManageAutomation: false,
    baseAutomationUrl: '',
    analyticsSource: 'smartCardAutomationAction'
  };
};